import { render } from "./dateTime.vue?vue&type=template&id=2bcb6fc4&ts=true"
import script from "./dateTime.vue?vue&type=script&lang=tsx"
export * from "./dateTime.vue?vue&type=script&lang=tsx"

import "./dateTime.vue?vue&type=style&index=0&id=2bcb6fc4&lang=less"

import exportComponent from "E:\\qihe\\ly-visitor\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__